import React from 'react';
import { GLASS_CARD } from '../../../constants/theme';

interface CardProps {
    children: React.ReactNode;
    /** Bootstrap / utility classes for padding, margin, etc. */
    className?: string;
    /** Extra inline overrides — e.g. a gradient background for the plan card */
    style?: React.CSSProperties;
    /** Adds the standard page-level card shadow */
    shadow?: boolean;
    /** HTML element to render (default: 'div') */
    as?: React.ElementType;
    [key: string]: unknown;
}

/**
 * Glass-morphism card — Bootstrap 5 / theme-aware, no hardcoded colours.
 * When migrating to Tailwind, replace the inline `style` with utility classes here only.
 */
export const Card: React.FC<CardProps> = ({
    children,
    className = '',
    style = {},
    shadow = false,
    as: Tag = 'div',
    ...rest
}) => (
    <Tag
        className={className}
        style={{
            ...(GLASS_CARD as React.CSSProperties),
            ...(shadow ? { boxShadow: '0 4px 24px rgba(var(--bs-primary-rgb), 0.08)' } : {}),
            ...style,
        }}
        {...rest}
    >
        {children}
    </Tag>
);

export default Card;
